import { Button } from '@harvesthq/porchlight'
import classNames from 'classnames'

import { signOut } from '../lib/authentication'
import { accountsUrl } from '../lib/urls'
import { switchOrSelectAccount } from '../lib/util'

import { Header } from './Header'

const switchAccountOrSignOutButton = (chromeless, userCanSwitchAccounts) => {
  if (!chromeless) return null

  if (userCanSwitchAccounts) {
    return (
      <Button
        aria-label="Switch account."
        label="Switch account"
        className="pds-mr-sm"
        variant="link"
        onClick={() => switchOrSelectAccount(accountsUrl)}
      />
    )
  }
  return (
    <Button
      aria-label="Sign out."
      label="Sign out"
      className="pds-mr-sm"
      variant="cancel"
      onClick={signOut}
    />
  )
}

export const NoProjects = ({
  baseUri,
  userCanSwitchAccounts,
  userCanCreateProjects,
  noProjectHasTasks,
  chromeless,
  closable,
  closeForm,
  externalGroupName,
  createProjectUrl,
}) => {
  const formClassName = classNames({ 'pds-p-md': !chromeless })
  const projectsUrl = new URL('/projects', baseUri)

  let message =
    'Ask an Administrator to assign you to a project so you can track time.'

  if (userCanCreateProjects) {
    if (createProjectUrl) {
      message = `Create this project
              ${
                externalGroupName && `(${externalGroupName}) `
              }or assign yourself
              to one so you can track time.`
    } else {
      message =
        'Create a project or assign yourself to one so you can track time.'
    }
  }

  const createProjectButton = createProjectUrl && (
    <a
      href={createProjectUrl}
      className="pds-button pds-button-primary pds-mr-sm"
      target="_blank"
      rel="noopener"
    >
      Create this project
    </a>
  )

  const cancelButton = closable && (
    <Button
      label="Cancel"
      aria-label="Cancel."
      variant="cancel"
      onClick={closeForm}
    />
  )

  const manageProjectsClassNames = classNames('pds-button pds-mr-sm', {
    'pds-button-primary': !createProjectUrl,
  })

  const manageProjectsButton = userCanCreateProjects && (
    <a
      className={manageProjectsClassNames}
      href={projectsUrl.href}
      rel="noopener"
      target="_blank"
    >
      Manage projects
    </a>
  )

  return (
    <div className="pds-row pds-m-0">
      <div className="pds-column pds-p-0">
        {!chromeless && (
          <Header userCanSwitchAccounts={userCanSwitchAccounts} />
        )}
        <div className={formClassName}>
          <h4 className="pds-mb-sm">
            {noProjectHasTasks
              ? 'Your project assignments have no active tasks in Harvest'
              : 'You’re not assigned to any projects in Harvest'}
          </h4>
          <p>{message}</p>
          <div className="pds-field pds-pr-md pds-mb-0">
            {createProjectButton}
            {manageProjectsButton}
            {switchAccountOrSignOutButton(chromeless, userCanSwitchAccounts)}
            {cancelButton}
          </div>
        </div>
      </div>
    </div>
  )
}
